import axios from 'axios';

type MutationParams = {
    ruleId: number;
    startDt: Date;
    endDt: Date;
    conditions: string;
    actions: string;
    clientId: string;
    startDateString: string;
    endDateString: string;
};

let url = '';

export const initRuleTesterService = (config: Record<string, any>) => {
    url = config.ruleTester;
};

export const postRuleTester = async (params: MutationParams) => {
    const { data } = await axios.post(`${url}/create`, params);
    return data;
};

export const cancelRuleTester = async (
    ruleId: string,
    merchantId: string,
    tenantGroupId: string,
    ruleSetId: string
) => {
    return axios.patch(
        `${url}/cancel/${ruleId}?merchantId=${merchantId}&tenantGroupId=${tenantGroupId}&ruleSetId=${ruleSetId}`
    );
};

export const getRuleTestResults = async (
    id: string | null,
    merchantId: string,
    tenantGroupId: string,
    ruleSetId: string
) => {
    const { data } = await axios.get(`${url}/status`, {
        params: {
            ruleId: id,
            merchantId,
            tenantGroupId,
            ruleSetId
        }
    });
    return data;
};
